import { makeStyles, Theme } from '@material-ui/core';
import { TextColor } from '../../../../../../enums';

interface StyleProps {
  open?: boolean;
  width?: number | string;
  noBorder?: boolean;
  // ! This sloud be removed when we migrate whole app new design
  newDesign?: boolean;
}

export const useCustomSelectButtonStyles = makeStyles<Theme, StyleProps>(
  ({ spacing, palette }) => ({
    container: {
      height: 'fit-content',
      padding: '4px 12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: ({ width }) => width || 230,
      borderRadius: ({ newDesign }) => (newDesign ? 99 : 8),
      border: ({ open, newDesign }) =>
        `0.5px solid ${
          open
            ? palette.primary.main
            : `${newDesign ? '#AFBAC6' : TextColor.LightGrey}`
        }`,
      '& .MuiTouchRipple-root': {
        minHeight: 'inherit'
      }
    },
    label: {
      fontSize: 14,
      color: TextColor.Grey,
      paddingRight: spacing(1),
      display: 'flex',
      fontWeight: 400,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    valueWrapper: {
      overflow: 'hidden'
    },
    labelDetails: {
      fontSize: 14,
      fontWeight: 500
    },
    labelHighlight: {
      color: palette.primary.main
    },
    iconContainer: {
      display: 'flex',
      borderLeft: ({ noBorder, newDesign }) =>
        noBorder
          ? 'unset'
          : `0.5px solid ${newDesign ? '#AFBAC6' : TextColor.LightGrey}`,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: spacing(2),
      paddingLeft: spacing(1),

      '& svg': {
        transform: ({ open }) =>
          `rotate(${open ? '270deg' : '90deg'}) scale(0.6) !important `,
        fill: ({ open }: { open: boolean }) =>
          `${open ? palette.primary.main : TextColor.Grey}`,
        transition: 'all 0.3s ease-in-out'
      }
    }
  })
);
